/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgWarningTriangleIcon: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.8126 12.0015L9.21705 2.67541C9.09504 2.47037 8.91811 2.29982 8.7043 2.18117C8.4905 2.06252 8.24747 2 8.00002 2C7.75256 2 7.50954 2.06252 7.29573 2.18117C7.08193 2.29982 6.90499 2.47037 6.78299 2.67541L1.18745 12.0015C1.06412 12.2049 0.999457 12.4358 1 12.6707C1.00055 12.9055 1.06629 13.1361 1.19056 13.339C1.31483 13.5419 1.49321 13.7099 1.70762 13.826C1.92203 13.942 2.16485 14.0021 2.41147 13.9999H13.6026C13.848 13.9997 14.089 13.938 14.3015 13.8209C14.5139 13.7039 14.6903 13.5357 14.8129 13.3332C14.9356 13.1307 15.0001 12.9011 15 12.6673C14.9999 12.4336 14.9353 12.2039 14.8126 12.0015Z" />
    <path
      d="M8.00701 6.00615V8.67075M8.00701 11.3353H8.01401M14.8126 12.0015L9.21705 2.67541C9.09504 2.47037 8.91811 2.29982 8.7043 2.18117C8.4905 2.06252 8.24747 2 8.00002 2C7.75256 2 7.50954 2.06252 7.29573 2.18117C7.08193 2.29982 6.90499 2.47037 6.78299 2.67541L1.18745 12.0015C1.06412 12.2049 0.999457 12.4358 1 12.6707C1.00055 12.9055 1.06629 13.1361 1.19056 13.339C1.31483 13.5419 1.49321 13.7099 1.70762 13.826C1.92203 13.942 2.16485 14.0021 2.41147 13.9999H13.6026C13.848 13.9997 14.089 13.938 14.3015 13.8209C14.5139 13.7039 14.6903 13.5357 14.8129 13.3332C14.9356 13.1307 15.0001 12.9011 15 12.6673C14.9999 12.4336 14.9353 12.2039 14.8126 12.0015Z"
      stroke="#AE8305"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgWarningTriangleIcon;
